import { useColorScheme } from 'react-native';
import { lightTheme, darkTheme } from '../theme';
import { useUserPreferences } from './useUserPreferences';

export const useTheme = () => {
  const deviceColorScheme = useColorScheme();
  const { preferences } = useUserPreferences();

  // Determine which theme to use based on preferences
  let activeTheme = 'system';

  if (preferences.theme === 'light') {
    activeTheme = 'light';
  } else if (preferences.theme === 'dark') {
    activeTheme = 'dark';
  } else {
    // Use system setting if theme is set to 'system'
    activeTheme = deviceColorScheme || 'light';
  }

  const isDark = activeTheme === 'dark';

  // Return the appropriate theme based on the theme setting
  const theme = isDark ? darkTheme : lightTheme;
  const result = { ...theme, isDark };
  
  // Debug: Check if result is a valid object
  if (!result || typeof result !== 'object' || !result.colors) {
    console.error('[useTheme] Invalid theme result:', result);
  }
  
  return result;
};

export default useTheme;
